import { Card, CardContent, CardHeader, Skeleton, Tab, Tabs } from '@mui/material';
import { ChartContent } from './ChartContent';

const cardHeaderStyle = {
  borderBottom: 1,
  borderColor: 'divider',
  p: 0,
} as const;

export const TabChart = () => {
  return (
    <Card elevation={2}>
      <CardHeader
        sx={cardHeaderStyle}
        title={
          <Tabs variant="fullWidth" value={0}>
            {Array(2)
              .fill('')
              .map((_, idx) => (
                <Tab key={idx} label={<Skeleton variant="rectangular" width={245} height={24} />} />
              ))}
          </Tabs>
        }
      />
      <CardContent>
        <ChartContent />
      </CardContent>
    </Card>
  );
};
